import { graphql } from "@/gql";

export const deleteBillingEntityMutation = graphql(`
  mutation deleteBillingEntity($id: ID!) {
    deleteBillingEntity(id: $id)
  }
`);
